import styled from '@emotion/styled';
import { Label, SemanticCOLORS } from 'semantic-ui-react';

export const AuditHistoryActionLabel = ({ action }: { action: string }) => {
  let color: SemanticCOLORS = 'grey';

  switch (action.toLowerCase()) {
    case 'insert':
    case 'restore':
      color = 'green';
      break;
    case 'delete':
      color = 'red';
      break;
    case 'update':
      color = 'blue';
      break;
    default:
      break;
  }

  return (
    <S.Wrapper>
      <Label color={color} size="tiny">
        {action}
      </Label>
    </S.Wrapper>
  );
};

const S = {
  Wrapper: styled.div`
    text-align: center;
  `,
};
